import * as departmentActions from "./actions"

import { all, call, put, takeEvery } from "redux-saga/effects"
import {
  createDepartment,
  deleteDepartment,
  getAllDepartments,
  updateDepartment
} from "@src/services/apis"

import { DEPARTMENT_TYPES } from "./types"

function* getAllDepartmentsRequest(action) {
  try {
    const response = yield call(getAllDepartments, action.payload)
    yield put(departmentActions.getAllDepartmentsSuccess(response.data))
  } catch (err) {
    yield put(departmentActions.getAllDepartmentsFailure(err))
  }
}

function* createDepartmentRequest(action) {
  try {
    const response = yield call(createDepartment, action.payload)
    yield put(
      departmentActions.createDepartmentSuccess(response?.remaining_calls)
    )
  } catch (err) {
    yield put(departmentActions.createDepartmentFailure(err))
  }
}

function* updateDepartmentRequest(action) {
  try {
    const response = yield call(updateDepartment, action.payload)
    yield put(departmentActions.updateDepartmentSuccess(response.data))
  } catch (err) {
    yield put(departmentActions.updateDepartmentFailure(err))
  }
}

function* deleteDepartmentRequest(action) {
  try {
    const response = yield call(deleteDepartment, action.payload)
    yield put(
      departmentActions.deleteDepartmentSuccess(response?.remaining_calls)
    )
  } catch (err) {
    yield put(departmentActions.deleteDepartmentFailure(err))
  }
}

export default function* departmentSaga() {
  yield all([
    takeEvery(
      DEPARTMENT_TYPES.GET_ALL_DEPARTMENTS_REQUEST,
      getAllDepartmentsRequest
    ),
    takeEvery(
      DEPARTMENT_TYPES.CREATE_DEPARTMENT_REQUEST,
      createDepartmentRequest
    ),
    takeEvery(
      DEPARTMENT_TYPES.UPDATE_DEPARTMENT_REQUEST,
      updateDepartmentRequest
    ),
    takeEvery(
      DEPARTMENT_TYPES.DELETE_DEPARTMENT_REQUEST,
      deleteDepartmentRequest
    )
  ])
}
